export default {
  SearchPlaceholder: '请输入域名/IPV4/IPV6',
  DialTestObject: '拨测对象',
  DialingMethod: '拨测方式',
  DialSourceStation: '拨测源站（域名/IP）',
  IpType: '拨测源站地址类型',
  DialTestResult: '拨测结果',
  CompleteTime: '完成时间',
  DeleteConfirmTitle: '确定删除任务？',
  DeleteConfirmContent: '删除后不可恢复，如有需要可重新添加任务',
  AddTask: '新建任务',
  EditTask: '编辑任务',
  DialingDetails: '拨测详情',
  Customer: '客户名称',
  GatewayBranch: '网关分支',
  DomainNamePlaceholder: '输入源站地址，多个换行隔开',
  PortPlaceholder: '0-65535，默认80、443。多个逗号隔开，最多5个',
  CreateConfirmTitle: '确定提交任务?',
  CreateConfirmContent: '拨测完成后可以在平台查看拨测详情',
  EditConfirmTitle: '确定修改任务?',
  EditConfirmContent: '提交修改后，已拨测的结果将不会保存，任务将重新进行。',
  Unreachable: '不可达',
  PartiallyReachable: '部分可达',
  AllReachable: '全部可达',
  DialTime: '拨测时间',
  LastCompleteTime: '最近拨测完成时间',
  User: '用户',
  DomainAndIpMaxLength: (num: number) => `IP+域名最多${num}条`,
  DomainAndIpRequired: '域名和ip 必须填一个',
  EveryDay: '每天',
  Weekly: '每周',
  PerMonth: '每月',
  Quarterly: '每季',
  // 星期一到星期日
  Mon: '星期一',
  Tue: '星期二',
  Wed: '星期三',
  Thu: '星期四',
  Fri: '星期五',
  Sat: '星期六',
  Sun: '星期日',
  Day: '日',
  FirstMonth: '每季度首月',
  SecondMonth: '每季度次月',
  LastMonth: '每季度末月',
  MaxPortNum: (num: number) => `端口最多支持${num}个`,
  PortRange: '端口范围为0-65535',
  UpTo: '可达',
  RealTime: '实时',
  Dialing: '拨测进行中',
  CpeSearchPlaceholder: '搜索网关名/分支名/设备名',
  Week: '星期',
  Month: '月',
  Date: '日期',
  SelectAll: '选择全部',
  DialTestOutlet: '拨测出口',
  Area: '地区',
}